(function($){
  
//   window.onpageshow = function(event) {
//     if (event.persisted) {
//     window.location.reload();

//     }

//   };
  
 var app = {
        onReady: function(e){
          	app.preloader();
            app.customDropdown();     
        },	
        onLoad: function(e){
            app.utils();
        },


		utils: function(){
          $(window).scroll(function() {
            var button_up;
            var sticky = false;
            var top = $(window).scrollTop();

            if (top > 0) {

              $('.header-wrapper').addClass('is-stuck');
              $('.header-wrap').removeClass('is-anchored');
              sticky = true;

            } else {

              $('.header-wrapper').addClass('is-anchored');
              $('.header-wrapper').removeClass('is-stuck');
            }   
            
            /* Button Scroll Up */
            (button_up = function() {
              var button;
              button = $('.btn_scroll_up');
              if (top > $(window).offset().top){
                return button.fadeIn('slow');
              } else {
                return button.fadeOut('slow');
              }
            })();   

          }); 
          
           //Click event to scroll to top
            $('.btn_scroll_up').click(function(){
                $('html, body').animate({scrollTop : 0});
                return false;
            });  
        //smooth scroll
		$('a[href*="#"]').click(function (e) {
			var target = this.hash;
			var $target = $(target);
			var name = this.hash.slice(1);
			var offset = 0;
           var $windowWidth = $(window).width();
			
			target = target.length ? target : $('[name=' + name +']');

			if( $windowWidth <= 1023 ){
				offset = 150;
			}
			else {
				offset = 150;
			}
			
			offset = $target.offset().top - offset + 'px';
			
			$('html, body').stop().animate({
				scrollTop: offset
			}, 900, 'swing', function () {
				window.location.hash = target;
			});
		});

          $('.menu-drawer__menu-itemwrap').each(function(){
            
            $(this).click(function(){
              
              var parent_div = $(this).closest('.menu-drawer-item');

              if ( $(this).closest('.menu-drawer-item').hasClass('is-active') ) {
                $(this).find('details').removeClass('menu-opening');
                parent_div.removeClass('is-active'); 
              }              
              else {
              	parent_div.siblings().find('.menu-drawer__menu-wrap').removeClass('is-active');
                 parent_div.addClass('is-active');
              }
                            

            });
            
          });
          
          $('a.menu-drawer__menu-item').click(function(){
          		$(this).closest('details').removeAttr('open');        
          		$(this).closest('.menu-drawer-item').removeClass('is-active');                                
          });
          
          // hero-banner heading span first letter of each word
            hdr = $('.hero-banner .banner__heading');

            if ( hdr.length ) {

              str = hdr.attr("data-text").split(" ");
              hdr.empty();
              str.forEach(function(a) {
                hdr.append('<span>' + a.slice(0, 1) + '</span>' + a.slice(1) + ' ')
              })
            }

          
          // hero-banner subheading remove p element
            var subhdr = $('.hero-banner .banner__subheading');
            var par = $('.hero-banner .banner__subheading p');
            subhdr.html( par.html() );
          
            $('.reviews-list').slick({
              infinite: true,
              slidesToShow: 3,
              slidesToScroll: 3,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 325,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
            });
          
          
          //steps hover
          $('.section_steps .multicolumn-list__item').each(function(){
            var that = $(this);
            
            that.click(function(){
        	  that.hasClass("active") ? that.removeClass("active") : that.addClass("active");
            });
          });
          
            //beforeAfter
            $('.ba-item').each(function(){
                $(this).beforeAfter();
            });
          
          //faqs accordion
            $('.faqs-item > .faqs-question').click(function(j){
              
    			var dropDown = $(this).closest('.faqs-item').find('.faqs-answer');
               //$(this).closest('.faqs-list').find('.faqs-answer').not(dropDown).slideUp();

                if ($(this).hasClass('active')) {                  
                  	$(this).removeClass('active');
                } else {
                  
                    //$(this).closest('.faqs-list').find('.faqs-question.active').removeClass('active');
                    $(this).addClass('active');
                  }              

                dropDown.stop(false, true).slideToggle();
                j.preventDefault();

            });
          
          // enable slick
          $('.ct-slider').slick({
              infinite: true,
              slidesToShow: 4,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 1366,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 1023,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 610,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 325,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
            });          	
          
          $('.gallery_slider').slick({
              arrows: true,
              dots: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              speed: 500,
              fade: true
            });         

          
          $('.hero_slider').slick({
              arrows: false,
              dots: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              fade: true,
              autoplay: true,
              autoplaySpeed: 2000,
            });

        },
   
		
		preloader: function(){
			//preloader            
            $('#preloader').delay(100).fadeOut('slow');
		},

        customDropdown: function() {
             $('.custom_dropdown > li').hover(function(){
                $(this).addClass('hover');
            }, function(){
                $(this).removeClass('hover');
            })

            $('.custom_dropdown > li').click(function(){
                $(this).toggleClass('hover');
            });
            
        }
    };


    document.addEventListener('DOMContentLoaded', app.onReady);
    window.addEventListener('load', app.onLoad);

 })(jQuery);

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}